import { render, staticRenderFns } from "./pages20.vue?vue&type=template&id=0e64681f&scoped=true&"
import script from "./pages20.vue?vue&type=script&lang=js&"
export * from "./pages20.vue?vue&type=script&lang=js&"
import style0 from "./pages20.vue?vue&type=style&index=0&id=0e64681f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e64681f",
  null
  
)

export default component.exports